export const postLayoutPresets=[
  {id:'editorial',name:'Original Editorial'},
  {id:'bold',name:'Bold Statement'},
  {id:'quote',name:'Quote / Stat Card'},
  {id:'bottom',name:'Bottom-Anchored'},
  {id:'split',name:'Split Panel'},
  {id:'fullbleed',name:'Full Bleed Type'},
  {id:'framed',name:'Framed'},
  {
    id:'ledger',
    name:'The Ledger',
    description:'Fixed vertical spine with a bottom-anchored bleeding photo'
  }
];

export const postLayouts=postLayoutPresets.map((preset)=> preset.id);

export function selectRandomLayout(preferredLayouts=[]) {
  const validPreferences=preferredLayouts.filter(
    (layout)=> postLayouts.includes(layout)
  );

  if (!validPreferences.length || Math.random()<0.15) {
    return postLayouts[Math.floor(Math.random()*postLayouts.length)];
  }

  if (Math.random()<0.5) {
    return validPreferences[0];
  }

  return validPreferences[
    Math.floor(Math.random()*validPreferences.length)
  ];
}

export function getPostLayout(post) {
  if (post.layout && postLayouts.includes(post.layout)) {
    return post.layout;
  }

  const numericId=Number(post.id);

  if (Number.isFinite(numericId)) {
    return postLayouts[Math.abs(numericId)%postLayouts.length];
  }

  const seed=String(post.id || post.headline || '')
    .split('')
    .reduce(
      (total,character)=> total+character.charCodeAt(0),
      0
    );

  return postLayouts[seed%postLayouts.length];
}